<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dRGuLD/tc-custom/9781641086882.jpg?1713221746588" alt="This image is the cover for the book 12 Kittens of Christmas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">12 Kittens of Christmas
      </h1>
      <p class="bookDescription body article font2">
        <p>Killian Thornton likes his downtown life, tending bar, and enjoying time with his friends and community. He'd given up on passion long ago—he wasn't cut out for grand romance or dramatic gestures. Then one night, in a characteristic act of kindness, Killian offers his couch to help a friend's little brother find his feet in a new city, and everything Killian thought he knew about himself and his little life gets turned upside down.<br/><br/> Lewis Bernard, the funny, quirky guy happy to find a spot on Killian's couch, can’t believe his luck. After being forced to flee his parents’ house, he was afraid of what came next, but Sacramento seems to be treating him just fine. The stunningly handsome bartender who lives downstairs from his brother offers Lewis his couch and doesn’t even balk when Lewis discovers two abandoned kittens in a vacant lot as they walk home.<br/><br/> Vet bills, cat food bills, litter boxes—none of it was on Killian's Christmas agenda, but he jumps in gamely to help because all the shelters seem to be full, and that's just the kind of guy Killian is. But kittens can multiply faster than rabbits, and Killian and Lewis accidentally rescue more and more cats.<br/><br/> Lewis starts to panic. He really wants to know Killian better, but with each act of kindness, Lewis falls further in love while ruining Killian's life. How can Killian find time to fall in love with Lewis and ask him to stay if they’re inundated with destructive furry poop-machines who all seem to need a home before Christmas?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Lane
      </h2>
      
      <p class="authorDescription body article"><P>Award winning author Amy Lane lives in a crumbling crapmansion with a couple of teenagers, a passel of furbabies, and a bemused spouse. She has too damned much yarn, a penchant for action-adventure movies, and a need to know that somewhere in all the pain is a story of Wuv, Twu Wuv, which she continues to believe in to this day! She writes contemporary romance, paranormal romance, urban fantasy, and romantic suspense, teaches the occasional writing class, and likes to pretend her very simple life is as exciting as the lives of the people who live in her head. She&rsquo;ll also tell you that sacrifices, large and small, are worth the urge to write.</P><P>Website: www.greenshill.com</P><P>Blog: www.writerslane.blogspot.com</P><P>Email: amylane@greenshill.com</P><P>Facebook: www.facebook.com/amy.lane.167</P><P>Twitter: @amymaclane</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e611357e